export default __webpack_public_path__ + "00d7ff0.png";